import { FormattedMessage } from 'react-intl';
import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { compoundManagementSlice, getIncomingVehicleSorting } from '../../../reducers/compoundManagementSlice';
import { AppTableCardsSorting } from '../../../sharedComponents/table/AppTableCardsSorting';
import { TableSort } from '../../../sharedComponents/table/SortedTableHeader';
import { Table } from '../../../sharedComponents/table/Table';
import { useSelectedTableColumns } from '../../../sharedComponents/table/useSelectedTableColumns';
import { IncomingVehicle } from '../../compoundManagement.types';
import { CompoundManagementTableRow } from '../../shared/table/CompoundManagementTableRow';
import { IncomingSelectionCell } from './IncomingSelectionCell';
import { IncomingVehicleBulkSelectionDropdown } from './IncomingVehicleBulkSelectionDropdown';
import { IncomingVehiclesTableColumn } from './IncomingVehiclesTableColumn';
import { IncomingVehiclesTableDataContent } from './IncomingVehiclesTableDataContent';

type IncomingVehiclesTableProps = {
    readonly vehicles: readonly IncomingVehicle[];
};

export const IncomingVehiclesTable = ({ vehicles }: IncomingVehiclesTableProps) => {
    const sorting = useAppSelector(getIncomingVehicleSorting);
    const dispatch = useAppDispatch();

    const setSorting = (newSorting: TableSort<IncomingVehiclesTableColumn>) =>
        dispatch(compoundManagementSlice.actions.setIncomingSorting(newSorting));

    const columnDefinition = useSelectedTableColumns<IncomingVehiclesTableColumn>();

    return (
        <>
            <AppTableCardsSorting columnDefinition={columnDefinition} sorting={sorting} setSorting={setSorting} />
            <Table
                columnDefinition={columnDefinition}
                sorting={sorting}
                setSorting={setSorting}
                items={vehicles}
                notFoundMessage={
                    <FormattedMessage id="outboundOrderBook.compoundManagement.incomingVehicles.notFound" />
                }
                selectionHeader={<IncomingVehicleBulkSelectionDropdown />}
            >
                {vehicles.map((vehicle: IncomingVehicle) => (
                    <CompoundManagementTableRow
                        key={vehicle.id}
                        highlight={vehicle.arrival.isCancelled ? 'danger' : undefined}
                        columnDefinition={columnDefinition}
                        vehicle={vehicle}
                        selectionCell={<IncomingSelectionCell vehicleId={vehicle.id} />}
                    >
                        {(column) => <IncomingVehiclesTableDataContent column={column} vehicle={vehicle} />}
                    </CompoundManagementTableRow>
                ))}
            </Table>
        </>
    );
};
